import { css } from '@emotion/css';

export const livenessCam = css`
  * {
    font-family: Nunito !important;
  }
`;
